import React, { useMemo } from 'react';

import { SidePanelManagerContext, SidePanelManagerContextType } from './context';

type Props = SidePanelManagerContextType & {
    children?: React.ReactNode;
};
export const SidePanelManagerContextProvider: React.FC<Props> = ({ open, platform, children }) => {
    const context: SidePanelManagerContextType = useMemo(
        () => ({
            open,
            platform,
        }),
        [open, platform],
    );

    return (
        <SidePanelManagerContext.Provider value={context}>
            {children}
        </SidePanelManagerContext.Provider>
    );
};
